// extracted by mini-css-extract-plugin
module.exports = {"el_button":"Course_el_button_sc9vv","course_wrapper":"Course_course_wrapper_x62BU","course_content":"Course_course_content_2HGzG"};